import React, { useState } from 'react';

//Menu containing fixed functionalities
const MenuButton = ({ onOptionSelect, isDisabled}) => {
    const [isOpen, setIsOpen] = useState(false);

    const options = [
        { label: 'Get Quotes', value: 'get quotes' },
        { label: 'Get Prices', value: 'get prices' },
        { label: 'Become a Supplier', value: 'become a supplier' }
    ];

    const handleOptionClick = (value) => {
        onOptionSelect(value);
        setIsOpen(false);
    };

    return (
        <div className="menu-button-container">
            <button onClick={() => setIsOpen(!isOpen)} className={`menu-button ${isOpen ? 'open' : ''}`}><span className="material-icons-outlined">
                add
            </span>
            </button>
            {isOpen && (
                <div className="menu-options">
                    {options.map((option) => (
                        <button
                            key={option.value}
                            onClick={() => handleOptionClick(option.value)}
                            className="menu-option"
                            disabled={isDisabled}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MenuButton;